import React, { useEffect } from 'react';
import { sanitizeSchoolNoticeHtml } from '../../utils/schoolNoticeHtml';

export interface SchoolNoticeViewModalProps {
  title: string;
  bodyHtml: string;
  onClose: () => void;
  /** 하단 버튼 문구 (기본: 확인) */
  confirmLabel?: string;
  /** 「오늘 보이지 않기」 — 있으면 확인 왼쪽에 보조 버튼 표시 */
  onHideToday?: () => void;
  hideTodayLabel?: string;
  /** 배경 클릭으로 닫기 (기본 true) */
  dismissOnBackdrop?: boolean;
}

/** 로그인 공지와 동일한 룩의 공지 조회/미리보기 모달 */
const SchoolNoticeViewModal: React.FC<SchoolNoticeViewModalProps> = ({
  title,
  bodyHtml,
  onClose,
  confirmLabel = '확인',
  onHideToday,
  hideTodayLabel = '오늘 보이지 않기',
  dismissOnBackdrop = true,
}) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const safeHtml = sanitizeSchoolNoticeHtml(bodyHtml);
  const heading = (title ?? '').trim() || '공지사항';
  const dualActions = typeof onHideToday === 'function';

  return (
    <div
      className="cp-modal-backdrop cp-school-notice-login-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="cp-school-notice-view-title"
      onClick={dismissOnBackdrop ? onClose : undefined}
    >
      <div className="cp-modal cp-school-notice-login-modal" onClick={(e) => e.stopPropagation()}>
        <h2 id="cp-school-notice-view-title" className="cp-school-notice-login-title">
          {heading}
        </h2>
        <div
          className="cp-school-notice-login-body cp-school-notice-html"
          dangerouslySetInnerHTML={{
            __html: safeHtml || '<p class="cp-school-notice-login-empty">내용이 없습니다.</p>',
          }}
        />
        <div
          className={
            'cp-modal-footer cp-school-notice-login-footer' +
            (dualActions ? ' cp-school-notice-login-footer--dual' : '')
          }
        >
          {dualActions ? (
            <button type="button" className="cp-btn-secondary" onClick={onHideToday}>
              {hideTodayLabel}
            </button>
          ) : null}
          <button type="button" className="cp-btn-primary" onClick={onClose}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SchoolNoticeViewModal;
